import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function OrderIcon({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M6 8L7.75 20.28C7.81792 20.7606 8.05827 21.2 8.42624 21.5165C8.79421 21.8329 9.26469 22.0048 9.75 22H14.29C14.7753 22.0048 15.2458 21.8329 15.6138 21.5165C15.9817 21.2 16.2221 20.7606 16.29 20.28L18 8M5 8H19M7 15C7.79175 14.6683 8.64158 14.4975 9.5 14.4975C10.3584 14.4975 11.2083 14.6683 12 15C12.7917 15.3317 13.6416 15.5025 14.5 15.5025C15.3584 15.5025 16.2083 15.3317 17 15M12 8L13 2H15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default OrderIcon;
